export default class ScriptWorker {
  constructor (script) {
    if (script instanceof Function) {
      script = `(${script.toString()})();`;
    }
    const blob = new Blob([script], { type: 'application/javascript' });
    const url = URL.createObjectURL(blob);
    this.worker = new Worker(url);
    URL.revokeObjectURL(url);

    this.worker.onmessage = (e) => {
      this.onmessage(e);
    };
  }

  postMessage (message) {
    this.worker.postMessage(message);
  }

  onmessage () { /* to be supplied by consumer */ }

  terminate () {
    this.worker.terminate();
  }
}
